import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const TopAudiences = () => {
  const { topTroisaudiencesReports } = useSelector(
    (state) => state.rapportStatistiquesDetailllees
  );

  return (
    <div className="top_audiences">
      <h6>
        <FormattedMessage
          defaultMessage="top 3 audiences"
          id="detail_campagne_screen_8"
        />
      </h6>
      <ul>
        {topTroisaudiencesReports && topTroisaudiencesReports.length > 0 ? (
          topTroisaudiencesReports.map((item, index) => {
            let metric_string = "";
            let metric = 0;
            if (
              item.hasOwnProperty("ROAS omni_purchase_value") &&
              Number(item["ROAS omni_purchase_value"]) > 0
            ) {
              metric = Number(item["ROAS omni_purchase_value"]).toFixed(1);
              metric_string = "ROAS : " + metric;
            } else if (item.hasOwnProperty("Cost per inline_link_clicks")) {
              metric = Number(item["Cost per inline_link_clicks"]).toFixed(2);
              metric_string = "CPC : " + metric;
            }
            return (
              <li>
                <div className="left">
                  <span>{index + 1}</span>{" "}
                  {item && item.comb_value ? item.comb_value : ""}
                </div>
                <div className="right">
                  <div
                    style={{
                      width: `${metric}%`,
                    }}
                    className="chart"
                  ></div>
                  <p>{metric_string}</p>
                </div>
              </li>
            );
          })
        ) : (
          <p style={{ textAlign: "center" }}>Aucune donnée disponible</p>
        )}
      </ul>
    </div>
  );
};
export default TopAudiences;
